module.exports = __webpack_public_path__ + "static/media/IconPayOnsite.f1e4b7d8.png";